(function () {
  var root = document.getElementById('feLp');
  if (!root) return;

  /* ---------- Colorway data ---------- */
  var COLORS = {
    red: {
      accent: '#ED1C24',
      soft: 'rgba(237,28,36,0.12)',
      name: 'Race Red',
      titleHtml: 'Claim a<br>Race Red',
      hero: 'https://cdn.shopify.com/s/files/1/0853/3590/0465/files/101_Factory_Edition_Race_Red_Right_Crop.jpg?v=1785368038&width=1400',
      battery: 'https://cdn.shopify.com/s/files/1/0853/3590/0465/files/101FactoryEdtion-CloseUp-007-crop.jpg?v=1785367527&width=1100',
      url: 'https://101bikes.com/products/101-factory-edition-e-bikes?variant=55485060579633'
    },
    green: {
      accent: '#45C4B4',
      soft: 'rgba(69,196,180,0.12)',
      name: 'Seafoam Green',
      titleHtml: 'Claim a<br>Seafoam Green',
      hero: 'https://cdn.shopify.com/s/files/1/0853/3590/0465/files/101_Factory_Edition_Seafoam_Green_Right_crop.jpg?v=1785368037&width=1400',
      battery: 'https://cdn.shopify.com/s/files/1/0853/3590/0465/files/101FactoryEdtion-CloseUp-009-crop.jpg?v=1785367525&width=1100',
      url: 'https://101bikes.com/products/101-factory-edition-e-bikes?variant=55485060612401'
    }
  };

  window.feSetColor = function (key) {
    var c = COLORS[key];
    if (!c) return;

    root.style.setProperty('--acc', c.accent);
    root.style.setProperty('--acc-soft', c.soft);

    var heroShot = document.getElementById('feHeroShot');
    var orderShot = document.getElementById('feOrderShot');
    var batteryShot = document.getElementById('feBatteryShot');
    var heroBtn = document.getElementById('feHeroBtn');
    var orderBtn = document.getElementById('feOrderBtn');
    var orderTitle = document.getElementById('feOrderTitle');
    var stageCap = document.getElementById('feStageCap');

    if (heroShot) { heroShot.src = c.hero; heroShot.alt = '101 Factory Edition e-bike in ' + c.name; }
    if (orderShot) { orderShot.src = c.hero; orderShot.alt = '101 Factory Edition e-bike in ' + c.name; }
    if (batteryShot) { batteryShot.src = c.battery; }
    if (heroBtn) { heroBtn.href = c.url; heroBtn.textContent = 'Pre-order ' + c.name; }
    if (orderBtn) { orderBtn.href = c.url; }
    if (orderTitle) { orderTitle.innerHTML = c.titleHtml; }
    if (stageCap) { stageCap.textContent = c.name; }

    root.querySelectorAll('.fe-swatch').forEach(function (b) {
      b.classList.toggle('on', b.getAttribute('data-color') === key);
    });
  };

  /* ---------- Scroll reveal ---------- */
  var revealObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('on');
        revealObs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });
  root.querySelectorAll('.r').forEach(function (el) { revealObs.observe(el); });

  /* ---------- Count-up numbers ---------- */
  var counterObs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseInt(el.getAttribute('data-t'), 10);
      var duration = 1400;
      var startTime = null;

      function ease(t) { return 1 - Math.pow(1 - t, 4); }
      function step(now) {
        if (!startTime) startTime = now;
        var p = Math.min((now - startTime) / duration, 1);
        el.textContent = Math.floor(ease(p) * target).toLocaleString();
        if (p < 1) { requestAnimationFrame(step); }
        else { el.textContent = target.toLocaleString(); }
      }
      requestAnimationFrame(step);
      counterObs.unobserve(el);
    });
  }, { threshold: 0.5 });
  root.querySelectorAll('.ct').forEach(function (el) { counterObs.observe(el); });

  /* ---------- Smooth in-page scroll ---------- */
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(this.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      window.scrollTo({
        top: t.getBoundingClientRect().top + window.pageYOffset - 72,
        behavior: 'smooth'
      });
    });
  });
})();